import React from "react";
import "./Reports.scss";

function Reports() {
  return <div>Reports</div>;
}

export default Reports;
